import { CommandBarButton, createTheme, DirectionalHint, FontSizes, getTheme, IComboBoxStyles, ICommandBarStyleProps, ICommandBarStyles, ILabelStyleProps, ILabelStyles, IOverflowSetItemProps, IStackTokens, IStyleFunctionOrObject, ITextFieldStyles, ITheme, mergeStyleSets, NeutralColors, TooltipHost } from "@fluentui/react";
import { CSSProperties } from "styled-components";
import { helperFont, helperfontFamily } from "../helpers/helpers";

const theme = getTheme();

const themeTitle: ITheme = createTheme({
    fonts: {
        medium: {
            fontSize: '17px',
        },
    },
});

const classes = mergeStyleSets({
    icon: {
        fontSize: 50,
        height: 50,
        width: 50,
        margin: '0 25px',
    },
    iconFont: {
        padding: 0,
        fontSize: "16px",
        marginRight: 5,
    },
    base: {
        padding: '20px'
    },
    cardIcon: {
        marginBottom: '16px',
        height: 32,
        width: 32,
        fontSize: 32,
        color: theme.palette.themePrimary,
    },
});

const notPaddingSide: CSSProperties = {
    paddingRight: '0px',
    paddingLeft: '0px',
}

const notPaddingTableBase: CSSProperties = {
    paddingTop: '10px',
    ...notPaddingSide,
}

const stackTokens = { childrenGap: 10 };

const panelButtonStyle = { root: { marginRight: 8 } };

/* Table */
function _onRenderDetailsHeader(headerProps: any, defaultRender: any) {
    return defaultRender({
        ...headerProps,
        styles: {
            root: {
                paddingTop: '0px',
                textAlign: ''
            },
        },
    })
}

/* ComboBox inside CommandBar */
const notPaddingTopCombo: CSSProperties = {
    paddingTop: '6px',
}

/* Activity style - panel - list personas */
const activityClass = mergeStyleSets({
    exampleRoot: {
        marginTop: "20px",
    },
    nameText: {
        fontWeight: "bold",
    },
})

/**Estilo para ComboBox*/
const comboBoxStyles: Partial<IComboBoxStyles> = {
    label: {
        fontSize: FontSizes.size14,
        color: NeutralColors.gray140,
        // fontFamily: 'Arial,regular, Helvetica, sans-serif',
        // fontWeight: 'Semibold',
    }
};

const getLabelStyles = (props: ILabelStyleProps): ILabelStyles => {
    return {
        root: {
            fontSize: FontSizes.size14,
            color: NeutralColors.gray140,
            // fontFamily: 'Arial,regular, Helvetica, sans-serif',
            // fontWeight: 'Semibold'
        },
    };
}

const textFileStyles: Partial<ITextFieldStyles> = {
    subComponentStyles: {
        label: getLabelStyles,
    }
};

const commadStyles: IStyleFunctionOrObject<ICommandBarStyleProps, ICommandBarStyles> = {
    root: {
        padding: 2,
        margin: 0,
        borderBottom: theme.palette.neutralLight,
        borderBottomStyle: "solid",
        maxHeight: 30
    },
};

const commadStylesWithPadding: IStyleFunctionOrObject<ICommandBarStyleProps, ICommandBarStyles> = {
    root: {
        padding: '5px',
        margin: 0,
        borderBottom: theme.palette.neutralLight,
        borderBottomStyle: "solid",
        maxHeight: 30
    },
};

const telerikStyle = {
    position: 'relative',
    width: '100%',
    height: '85vh',
    clear: 'both',
    overflow: 'auto',
    fontFamily: 'ms sans serif'
}

const telerikStyleV2 = {
    position: 'relative',
    width: '99%',
    height: '95vh',
    clear: 'both',
    overflow: 'auto',
    fontFamily: 'ms sans serif'
}

const StackTokens10: IStackTokens = { childrenGap: 10 };
const StackTokens15: IStackTokens = { childrenGap: 15 };
const StackTokens20: IStackTokens = { childrenGap: 20 };

const _padding10 = { padding: 10 }
const _padding20 = { padding: 20 }

const _borderBottom: React.CSSProperties | undefined = {
    borderBottom: theme.palette.neutralLight,
    borderBottomStyle: "solid",
}

const pivotStyles = {
    text: { fontfamily: helperfontFamily, fontSize: 13 },
    root: { background: "#faf9f8" }
}

/* Icono */
const classNamesIcon = mergeStyleSets({
    iconFont: {
        padding: 0,
        fontSize: "16px",
        marginRight: 5,
        cursor: 'pointer',
    },
});

const onRenderOverflowButton = (overflowItems: any[] | undefined): JSX.Element => {
    return (
        <TooltipHost content="Opciones" directionalHint={DirectionalHint.rightCenter}>
            <CommandBarButton
                aria-label="More items"
                menuIconProps={{ iconName: 'CollapseMenu', style: { color: "blue" } }}
                // menuIconProps={{ iconName: 'MoreVertical' }}
                menuProps={{ items: overflowItems! }}
                styles={{ root: { background: "none" } }}
            />
        </TooltipHost>
    );
};

const onRenderItem = (item: IOverflowSetItemProps): JSX.Element => {
    return (
        <TooltipHost content={item.title} directionalHint={DirectionalHint.leftCenter}>
            <CommandBarButton
                aria-label={item.name}
                iconProps={{ iconName: item.icon }}
                onClick={item.onClick}
                styles={{ root: { background: "none" } }}
            />
        </TooltipHost>
    );
};

const colors_BaseMessaging = {
    Warning: '#fff4ce',
    Success: '#dff6dd',
    ErrorBlock: '#fde7e9',
    SevereWarning: '#fed9cc',
    SevereWarningIcon: '#d83b01',
    ErrorBlockIcon: '#a80000',
    SuccessIcon: '#107c10'
}
const colors_BaseProductos = {
    Skype: '#0078d4',
    OneDrive: '#0078d4',
    PowerPoint: '#b7472a',
    Word: '#2b579a',
    Visio: '#3955a3',
    Office: '#d83b01',
    Excel: '#217346',
    Teams: '#6264a7',
    Planner: '#31752f',
    toDo: '#212121'
}

const colors_IPERC = {
    A: '#736002',
    M: '#F2A30F',
    B: '#44803F',
    number: '#605e5c'
}

const colors_Bases = {
    blueLigth: '#ECF6FD',
    HeaderGroup: '#F3F2F1',
    BackgroundNavOutlook: "#F3F2F1",
    BackgroundToDo: "#FAF9F8",
    RowSelect: "#EEF6FB",
}

const borderSmoke = { border: 'Solid 1px #ccc' }
const activityClass2 = mergeStyleSets({
    exampleRoot: {
        marginTop: "20px",
    },
    paddingMin: {
        marginTop: "10px",
    },
    nameText: {
        fontWeight: "bold",
    },
});

const themeBase = {
    theme,
    colorsBaseMessaging: colors_BaseMessaging,
    colorsBaseProductos: colors_BaseProductos,
    colors_IPERC,
    colors_Bases,
    themeTitle,
    classes,
    stackTokens,
    notPaddingTableBase,
    notPaddingSide,
    panelButtonStyle,
    /* Table */
    _onRenderDetailsHeader,
    onRenderOverflowButton,
    onRenderItem,
    activityClass2,

    /* Activity */
    activityClass,

    /* Combo inside CommandBar */
    notPaddingTopCombo,

    /*ComboBox estilos*/
    comboBoxStyles,
    textFileStyles,

    /**Estilo Telerik*/
    telerikStyle,
    telerikStyleV2,

    /**Estilos commadStyles  */
    commadStyles,
    commadStylesWithPadding,
    pivotStyles,

    /**Tokens*/
    StackTokens10,
    StackTokens15,
    StackTokens20,

    _padding10,
    _padding20,
    _borderBottom,
    classNamesIcon,
    borderSmoke,
}

export default themeBase;